
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tcs-uk",
      function () {
        return require("private-next-pages/tcs-uk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tcs-uk"])
      });
    }
  